"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/*
  This is a temporary solution to enable the team to start practicing and using
  Signet Tokens. This file will be removed once the TS implementation of Signet Tokens
  is working. A ticket has been created for Design:
  https://app.shortcut.com/episource/story/148693/get-typescript-signet-tokens-to-work
*/
var _default = {
  primary: {
    main: {
      value: '#883907',
      type: 'color',
      description: 'Analyst primary color',
      filePath: 'tokens/analyst.json',
      isSource: true,
      original: {
        value: '{orange.500}',
        type: 'color',
        description: 'Analyst primary color'
      },
      name: 'PRIMARY_MAIN',
      attributes: {},
      path: ['primary', 'main']
    },
    light: {
      value: '#BD6434',
      type: 'color',
      description: 'Primary light',
      filePath: 'tokens/analyst.json',
      isSource: true,
      original: {
        value: '{orange.200}',
        type: 'color',
        description: 'Primary light'
      },
      name: 'PRIMARY_LIGHT',
      attributes: {},
      path: ['primary', 'light']
    },
    dark: {
      value: '#570A00',
      type: 'color',
      description: 'Primary dark',
      filePath: 'tokens/analyst.json',
      isSource: true,
      original: {
        value: '{orange.700}',
        type: 'color',
        description: 'Primary dark'
      },
      name: 'PRIMARY_DARK',
      attributes: {},
      path: ['primary', 'dark']
    },
    marketing: {
      value: '#F47321',
      type: 'color',
      description: 'Primary marketing',
      filePath: 'tokens/analyst.json',
      isSource: true,
      original: {
        value: '{orange.A400}',
        type: 'color',
        description: 'Primary marketing'
      },
      name: 'PRIMARY_MARKETING',
      attributes: {},
      path: ['primary', 'marketing']
    }
  },
  text: {
    primary: {
      value: 'rgba(0, 0, 0, 87%)',
      type: 'color',
      description: 'Primary text color',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'rgba(0, 0, 0, 87%)',
        type: 'color',
        description: 'Primary text color'
      },
      name: 'TEXT_PRIMARY',
      attributes: {},
      path: ['text', 'primary']
    },
    secondary: {
      value: 'rgba(0, 0, 0, 60%)',
      type: 'color',
      description: 'Secondary text color',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'rgba(0, 0, 0, 60%)',
        type: 'color',
        description: 'Secondary text color'
      },
      name: 'TEXT_SECONDARY',
      attributes: {},
      path: ['text', 'secondary']
    },
    highlight: {
      value: '#883907',
      type: 'color',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '{primary.main}',
        type: 'color'
      },
      name: 'TEXT_HIGHLIGHT',
      attributes: {},
      path: ['text', 'highlight']
    },
    contrastColor: {
      value: '#ffffff',
      type: 'color',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '{pure.white}',
        type: 'color'
      },
      name: 'TEXT_CONTRAST_COLOR',
      attributes: {},
      path: ['text', 'contrastColor']
    }
  },
  icon: {
    "default": {
      value: 'rgba(0, 0, 0, 60%)',
      type: 'color',
      description: 'Icon default state',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'rgba(0, 0, 0, 60%)',
        type: 'color',
        description: 'Icon default state'
      },
      name: 'ICON_DEFAULT',
      attributes: {},
      path: ['icon', 'default']
    },
    hover: {
      value: 'rgba(0, 0, 0, 87%)',
      type: 'color',
      description: 'Icon hover state',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'rgba(0, 0, 0, 87%)',
        type: 'color',
        description: 'Icon hover state'
      },
      name: 'ICON_HOVER',
      attributes: {},
      path: ['icon', 'hover']
    },
    active: {
      value: 'rgba(136, 57, 7, 54%)',
      type: 'color',
      description: 'Icon default state',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'rgba(136, 57, 7, 54%)',
        type: 'color',
        description: 'Icon default state'
      },
      name: 'ICON_ACTIVE',
      attributes: {},
      path: ['icon', 'active']
    },
    hoverBackground: {
      value: 'rgba(0, 0, 0, 8%)',
      type: 'color',
      description: 'Icon hover state background',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'rgba(0, 0, 0, 8%)',
        type: 'color',
        description: 'Icon hover state background'
      },
      name: 'ICON_HOVER_BACKGROUND',
      attributes: {},
      path: ['icon', 'hoverBackground']
    },
    clickedBackground: {
      value: 'rgba(0, 0, 0, 12%)',
      type: 'color',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'rgba(0, 0, 0, 12%)',
        type: 'color'
      },
      name: 'ICON_CLICKED_BACKGROUND',
      attributes: {},
      path: ['icon', 'clickedBackground']
    }
  },
  action: {
    "default": {
      value: '#883907',
      type: 'color',
      description: 'Main color for default call to action',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '{primary.main}',
        type: 'color',
        description: 'Main color for default call to action'
      },
      name: 'ACTION_DEFAULT',
      attributes: {},
      path: ['action', 'default']
    },
    hover: {
      value: '#570A00',
      type: 'color',
      description: 'Main color for hover call to action',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '{primary.dark}',
        type: 'color',
        description: 'Main color for hover call to action'
      },
      name: 'ACTION_HOVER',
      attributes: {},
      path: ['action', 'hover']
    },
    oultinedBorder: {
      value: 'rgba(136, 57, 7, 50%)',
      type: 'color',
      description: 'Used for outlined variant components in resting state (Button, Chip, etc)',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'rgba(136, 57, 7, 50%)',
        type: 'color',
        description: 'Used for outlined variant components in resting state (Button, Chip, etc)'
      },
      name: 'ACTION_OULTINED_BORDER',
      attributes: {},
      path: ['action', 'oultinedBorder']
    },
    outlinedHoverBackground: {
      value: 'rgba(136, 57, 7, 8%)',
      type: 'color',
      description: 'Fill background color for outlined & text variant components in hover state (Button, etc)',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'rgba(136, 57, 7, 8%)',
        type: 'color',
        description: 'Fill background color for outlined & text variant components in hover state (Button, etc)'
      },
      name: 'ACTION_OUTLINED_HOVER_BACKGROUND',
      attributes: {},
      path: ['action', 'outlinedHoverBackground']
    }
  },
  stateBackground: {
    hover: {
      value: 'rgba(136, 57, 7, 4%)',
      type: 'color',
      description: 'Fill background for components in hover state (List, Table, etc)',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'rgba(136, 57, 7, 4%)',
        type: 'color',
        description: 'Fill background for components in hover state (List, Table, etc)'
      },
      name: 'STATE_BACKGROUND_HOVER',
      attributes: {},
      path: ['stateBackground', 'hover']
    },
    selected: {
      value: 'rgba(136, 57, 7, 8%)',
      type: 'color',
      description: 'Fill background for components in selected state (List, Table, etc)',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'rgba(136, 57, 7, 8%)',
        type: 'color',
        description: 'Fill background for components in selected state (List, Table, etc)'
      },
      name: 'STATE_BACKGROUND_SELECTED',
      attributes: {},
      path: ['stateBackground', 'selected']
    },
    focus: {
      value: 'rgba(136, 57, 7, 12%)',
      type: 'color',
      description: 'Fill background for components in focus state (List, Table, etc)',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'rgba(136, 57, 7, 12%)',
        type: 'color',
        description: 'Fill background for components in focus state (List, Table, etc)'
      },
      name: 'STATE_BACKGROUND_FOCUS',
      attributes: {},
      path: ['stateBackground', 'focus']
    }
  },
  solidBackground: {
    mainContent: {
      value: '#ffffff',
      type: 'color',
      description: 'White background for main content container and card on general application background',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '{pure.white}',
        type: 'color',
        description: 'White background for main content container and card on general application background'
      },
      name: 'SOLID_BACKGROUND_MAIN_CONTENT',
      attributes: {},
      path: ['solidBackground', 'mainContent']
    },
    generalApp: {
      value: '#F8F6F4',
      type: 'color',
      description: 'Systeme background color for all app',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '{cream.50}',
        type: 'color',
        description: 'Systeme background color for all app'
      },
      name: 'SOLID_BACKGROUND_GENERAL_APP',
      attributes: {},
      path: ['solidBackground', 'generalApp']
    },
    generalDarker: {
      value: '#F3F1EE',
      type: 'color',
      description: 'Alternative to general app  background color',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '{cream.100}',
        type: 'color',
        description: 'Alternative to general app  background color'
      },
      name: 'SOLID_BACKGROUND_GENERAL_DARKER',
      attributes: {},
      path: ['solidBackground', 'generalDarker']
    },
    header: {
      value: '#F8F6F4',
      type: 'color',
      description: 'background fior the pager header',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '{cream.50}',
        type: 'color',
        description: 'background fior the pager header'
      },
      name: 'SOLID_BACKGROUND_HEADER',
      attributes: {},
      path: ['solidBackground', 'header']
    },
    tooltip: {
      value: 'rgba(0, 0, 0, 92%)',
      type: 'color',
      description: 'Background for tooltip',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'rgba(0, 0, 0, 92%)',
        type: 'color',
        description: 'Background for tooltip'
      },
      name: 'SOLID_BACKGROUND_TOOLTIP',
      attributes: {},
      path: ['solidBackground', 'tooltip']
    },
    filledInput: {
      value: 'rgba(0, 0, 0, 9%)',
      type: 'color',
      description: 'Background for filled input',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'rgba(0, 0, 0, 9%)',
        type: 'color',
        description: 'Background for filled input'
      },
      name: 'SOLID_BACKGROUND_FILLED_INPUT',
      attributes: {},
      path: ['solidBackground', 'filledInput']
    },
    overlay: {
      value: 'rgba(0, 0, 0, 5%)',
      type: 'color',
      description: 'Backdrop overlay',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'rgba(0, 0, 0, 5%)',
        type: 'color',
        description: 'Backdrop overlay'
      },
      name: 'SOLID_BACKGROUND_OVERLAY',
      attributes: {},
      path: ['solidBackground', 'overlay']
    },
    snackBar: {
      value: 'rgba(0, 0, 0, 78%)',
      type: 'color',
      description: 'Background for snack Bar',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'rgba(0, 0, 0, 78%)',
        type: 'color',
        description: 'Background for snack Bar'
      },
      name: 'SOLID_BACKGROUND_SNACK_BAR',
      attributes: {},
      path: ['solidBackground', 'snackBar']
    }
  },
  leftNavElement: {
    elementDefault: {
      value: 'rgba(0, 0, 0, 67%)',
      type: 'color',
      description: 'Color for nav element in default state',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'rgba(0, 0, 0, 67%)',
        type: 'color',
        description: 'Color for nav element in default state'
      },
      name: 'LEFT_NAV_ELEMENT_ELEMENT_DEFAULT',
      attributes: {},
      path: ['leftNavElement', 'elementDefault']
    },
    backgroundDefault: {
      value: '#F8F6F4',
      type: 'color',
      description: 'Background color for the left nav element in default state',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '{cream.50}',
        type: 'color',
        description: 'Background color for the left nav element in default state'
      },
      name: 'LEFT_NAV_ELEMENT_BACKGROUND_DEFAULT',
      attributes: {},
      path: ['leftNavElement', 'backgroundDefault']
    },
    elementHover: {
      value: 'rgba(0, 0, 0, 87%)',
      type: 'color',
      description: 'Color for nav element in hover state',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'rgba(0, 0, 0, 87%)',
        type: 'color',
        description: 'Color for nav element in hover state'
      },
      name: 'LEFT_NAV_ELEMENT_ELEMENT_HOVER',
      attributes: {},
      path: ['leftNavElement', 'elementHover']
    },
    backgroundHover: {
      value: '#ffffff',
      type: 'color',
      description: 'Background color for the left nav element in hover state',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '{pure.white}',
        type: 'color',
        description: 'Background color for the left nav element in hover state'
      },
      name: 'LEFT_NAV_ELEMENT_BACKGROUND_HOVER',
      attributes: {},
      path: ['leftNavElement', 'backgroundHover']
    },
    elementSelected: {
      value: '#883907',
      type: 'color',
      description: 'Color for nav element in default state',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '{primary.main}',
        type: 'color',
        description: 'Color for nav element in default state'
      },
      name: 'LEFT_NAV_ELEMENT_ELEMENT_SELECTED',
      attributes: {},
      path: ['leftNavElement', 'elementSelected']
    },
    backgroundSelected: {
      value: '#ffffff',
      type: 'color',
      description: 'Background color for the left nav element in selected state',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '{pure.white}',
        type: 'color',
        description: 'Background color for the left nav element in selected state'
      },
      name: 'LEFT_NAV_ELEMENT_BACKGROUND_SELECTED',
      attributes: {},
      path: ['leftNavElement', 'backgroundSelected']
    },
    leftIndicator: {
      value: '#883907',
      type: 'color',
      description: 'Color for the left indicator of the selected element',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '{primary.main}',
        type: 'color',
        description: 'Color for the left indicator of the selected element'
      },
      name: 'LEFT_NAV_ELEMENT_LEFT_INDICATOR',
      attributes: {},
      path: ['leftNavElement', 'leftIndicator']
    }
  },
  other: {
    divider: {
      value: 'rgba(0, 0, 0, 12%)',
      type: 'color',
      description: 'Divider color',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'rgba(0, 0, 0, 12%)',
        type: 'color',
        description: 'Divider color'
      },
      name: 'OTHER_DIVIDER',
      attributes: {},
      path: ['other', 'divider']
    },
    tree: {
      value: 'rgba(0, 0, 0, 20%)',
      type: 'color',
      description: 'Color for visible tree hierarchy',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'rgba(0, 0, 0, 20%)',
        type: 'color',
        description: 'Color for visible tree hierarchy'
      },
      name: 'OTHER_TREE',
      attributes: {},
      path: ['other', 'tree']
    },
    outlineBorder: {
      value: 'rgba(0, 0, 0, 23%)',
      type: 'color',
      description: 'Color for outline border',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'rgba(0, 0, 0, 23%)',
        type: 'color',
        description: 'Color for outline border'
      },
      name: 'OTHER_OUTLINE_BORDER',
      attributes: {},
      path: ['other', 'outlineBorder']
    },
    standardInputLine: {
      value: 'rgba(0, 0, 0, 42%)',
      type: 'color',
      description: 'Border style for standard variant Text Field & Select',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'rgba(0, 0, 0, 42%)',
        type: 'color',
        description: 'Border style for standard variant Text Field & Select'
      },
      name: 'OTHER_STANDARD_INPUT_LINE',
      attributes: {},
      path: ['other', 'standardInputLine']
    }
  },
  chart: {
    '1': {
      value: '#99952E',
      type: 'color',
      description: 'Color for graph',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '#99952E',
        type: 'color',
        description: 'Color for graph'
      },
      name: 'CHART_1',
      attributes: {},
      path: ['chart', '1']
    },
    '2': {
      value: '#6CC8D1',
      type: 'color',
      description: 'Color for graph',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '#6CC8D1',
        type: 'color',
        description: 'Color for graph'
      },
      name: 'CHART_2',
      attributes: {},
      path: ['chart', '2']
    },
    '3': {
      value: '#4B1864',
      type: 'color',
      description: 'Color for graph',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '#4B1864',
        type: 'color',
        description: 'Color for graph'
      },
      name: 'CHART_3',
      attributes: {},
      path: ['chart', '3']
    },
    '4': {
      value: '#29387B',
      type: 'color',
      description: 'Color for graph',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '#29387B',
        type: 'color',
        description: 'Color for graph'
      },
      name: 'CHART_4',
      attributes: {},
      path: ['chart', '4']
    },
    '5': {
      value: '#E37134',
      type: 'color',
      description: 'Color for graph',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '#E37134',
        type: 'color',
        description: 'Color for graph'
      },
      name: 'CHART_5',
      attributes: {},
      path: ['chart', '5']
    },
    '6': {
      value: '#9D5A9C',
      type: 'color',
      description: 'Color for graph',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '#9D5A9C',
        type: 'color',
        description: 'Color for graph'
      },
      name: 'CHART_6',
      attributes: {},
      path: ['chart', '6']
    },
    '7': {
      value: '#518BF8',
      type: 'color',
      description: 'Color for graph',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '#518BF8',
        type: 'color',
        description: 'Color for graph'
      },
      name: 'CHART_7',
      attributes: {},
      path: ['chart', '7']
    },
    '8': {
      value: '#7065E6',
      type: 'color',
      description: 'Color for graph',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '#7065E6',
        type: 'color',
        description: 'Color for graph'
      },
      name: 'CHART_8',
      attributes: {},
      path: ['chart', '8']
    },
    '9': {
      value: '#CA5559',
      type: 'color',
      description: 'Color for graph',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '#CA5559',
        type: 'color',
        description: 'Color for graph'
      },
      name: 'CHART_9',
      attributes: {},
      path: ['chart', '9']
    },
    '10': {
      value: '#1B444F',
      type: 'color',
      description: 'Color for graph',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '#1B444F',
        type: 'color',
        description: 'Color for graph'
      },
      name: 'CHART_10',
      attributes: {},
      path: ['chart', '10']
    },
    '11': {
      value: '#FA868C',
      type: 'color',
      description: 'Color for graph',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '#FA868C',
        type: 'color',
        description: 'Color for graph'
      },
      name: 'CHART_11',
      attributes: {},
      path: ['chart', '11']
    },
    '12': {
      value: '#882F68',
      type: 'color',
      description: 'Color for graph',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '#882F68',
        type: 'color',
        description: 'Color for graph'
      },
      name: 'CHART_12',
      attributes: {},
      path: ['chart', '12']
    },
    '13': {
      value: '#F2B23E',
      type: 'color',
      description: 'Color for graph',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '#F2B23E',
        type: 'color',
        description: 'Color for graph'
      },
      name: 'CHART_13',
      attributes: {},
      path: ['chart', '13']
    },
    '14': {
      value: '#307F9B',
      type: 'color',
      description: 'Color for graph',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '#307F9B',
        type: 'color',
        description: 'Color for graph'
      },
      name: 'CHART_14',
      attributes: {},
      path: ['chart', '14']
    },
    '15': {
      value: '#B3B0AD',
      type: 'color',
      description: 'Color for graph',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '#B3B0AD',
        type: 'color',
        description: 'Color for graph'
      },
      name: 'CHART_15',
      attributes: {},
      path: ['chart', '15']
    }
  },
  fontFamilies: {
    lato: {
      value: 'Lato',
      type: 'fontFamilies',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'Lato',
        type: 'fontFamilies'
      },
      name: 'FONT_FAMILIES_LATO',
      attributes: {},
      path: ['fontFamilies', 'lato']
    },
    roboto: {
      value: 'Roboto',
      type: 'fontFamilies',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'Roboto',
        type: 'fontFamilies'
      },
      name: 'FONT_FAMILIES_ROBOTO',
      attributes: {},
      path: ['fontFamilies', 'roboto']
    }
  },
  lineHeights: {
    '0': {
      value: '120%',
      type: 'lineHeights',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '120%',
        type: 'lineHeights'
      },
      name: 'LINE_HEIGHTS_0',
      attributes: {},
      path: ['lineHeights', '0']
    },
    '1': {
      value: '115%',
      type: 'lineHeights',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '115%',
        type: 'lineHeights'
      },
      name: 'LINE_HEIGHTS_1',
      attributes: {},
      path: ['lineHeights', '1']
    },
    '2': {
      value: '130%',
      type: 'lineHeights',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '130%',
        type: 'lineHeights'
      },
      name: 'LINE_HEIGHTS_2',
      attributes: {},
      path: ['lineHeights', '2']
    },
    '3': {
      value: '160%',
      type: 'lineHeights',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '160%',
        type: 'lineHeights'
      },
      name: 'LINE_HEIGHTS_3',
      attributes: {},
      path: ['lineHeights', '3']
    },
    '4': {
      value: '150%',
      type: 'lineHeights',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '150%',
        type: 'lineHeights'
      },
      name: 'LINE_HEIGHTS_4',
      attributes: {},
      path: ['lineHeights', '4']
    },
    '5': {
      value: '140%',
      type: 'lineHeights',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '140%',
        type: 'lineHeights'
      },
      name: 'LINE_HEIGHTS_5',
      attributes: {},
      path: ['lineHeights', '5']
    }
  },
  fontWeights: {
    'lato-0': {
      value: 'Regular',
      type: 'fontWeights',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'Regular',
        type: 'fontWeights'
      },
      name: 'FONT_WEIGHTS_LATO_0',
      attributes: {},
      path: ['fontWeights', 'lato-0']
    },
    'lato-1': {
      value: 'Medium',
      type: 'fontWeights',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'Medium',
        type: 'fontWeights'
      },
      name: 'FONT_WEIGHTS_LATO_1',
      attributes: {},
      path: ['fontWeights', 'lato-1']
    },
    'lato-2': {
      value: 'SemiBold',
      type: 'fontWeights',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'SemiBold',
        type: 'fontWeights'
      },
      name: 'FONT_WEIGHTS_LATO_2',
      attributes: {},
      path: ['fontWeights', 'lato-2']
    },
    'lato-3': {
      value: 'Bold',
      type: 'fontWeights',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'Bold',
        type: 'fontWeights'
      },
      name: 'FONT_WEIGHTS_LATO_3',
      attributes: {},
      path: ['fontWeights', 'lato-3']
    },
    'roboto-4': {
      value: 'Regular',
      type: 'fontWeights',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'Regular',
        type: 'fontWeights'
      },
      name: 'FONT_WEIGHTS_ROBOTO_4',
      attributes: {},
      path: ['fontWeights', 'roboto-4']
    }
  },
  fontSize: {
    '0': {
      value: '9',
      type: 'fontSizes',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '9',
        type: 'fontSizes'
      },
      name: 'FONT_SIZE_0',
      attributes: {},
      path: ['fontSize', '0']
    },
    '1': {
      value: '10',
      type: 'fontSizes',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '10',
        type: 'fontSizes'
      },
      name: 'FONT_SIZE_1',
      attributes: {},
      path: ['fontSize', '1']
    },
    '2': {
      value: '11',
      type: 'fontSizes',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '11',
        type: 'fontSizes'
      },
      name: 'FONT_SIZE_2',
      attributes: {},
      path: ['fontSize', '2']
    },
    '3': {
      value: '12',
      type: 'fontSizes',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '12',
        type: 'fontSizes'
      },
      name: 'FONT_SIZE_3',
      attributes: {},
      path: ['fontSize', '3']
    },
    '4': {
      value: '13',
      type: 'fontSizes',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '13',
        type: 'fontSizes'
      },
      name: 'FONT_SIZE_4',
      attributes: {},
      path: ['fontSize', '4']
    },
    '5': {
      value: '14',
      type: 'fontSizes',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '14',
        type: 'fontSizes'
      },
      name: 'FONT_SIZE_5',
      attributes: {},
      path: ['fontSize', '5']
    },
    '6': {
      value: '15',
      type: 'fontSizes',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '15',
        type: 'fontSizes'
      },
      name: 'FONT_SIZE_6',
      attributes: {},
      path: ['fontSize', '6']
    },
    '7': {
      value: '17',
      type: 'fontSizes',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '17',
        type: 'fontSizes'
      },
      name: 'FONT_SIZE_7',
      attributes: {},
      path: ['fontSize', '7']
    },
    '8': {
      value: '18',
      type: 'fontSizes',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '18',
        type: 'fontSizes'
      },
      name: 'FONT_SIZE_8',
      attributes: {},
      path: ['fontSize', '8']
    },
    '9': {
      value: '21',
      type: 'fontSizes',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '21',
        type: 'fontSizes'
      },
      name: 'FONT_SIZE_9',
      attributes: {},
      path: ['fontSize', '9']
    },
    '10': {
      value: '22',
      type: 'fontSizes',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '22',
        type: 'fontSizes'
      },
      name: 'FONT_SIZE_10',
      attributes: {},
      path: ['fontSize', '10']
    },
    '11': {
      value: '25',
      type: 'fontSizes',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '25',
        type: 'fontSizes'
      },
      name: 'FONT_SIZE_11',
      attributes: {},
      path: ['fontSize', '11']
    },
    '12': {
      value: '36',
      type: 'fontSizes',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '36',
        type: 'fontSizes'
      },
      name: 'FONT_SIZE_12',
      attributes: {},
      path: ['fontSize', '12']
    },
    '13': {
      value: '51',
      type: 'fontSizes',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '51',
        type: 'fontSizes'
      },
      name: 'FONT_SIZE_13',
      attributes: {},
      path: ['fontSize', '13']
    },
    '14': {
      value: '63',
      type: 'fontSizes',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '63',
        type: 'fontSizes'
      },
      name: 'FONT_SIZE_14',
      attributes: {},
      path: ['fontSize', '14']
    },
    '15': {
      value: '101',
      type: 'fontSizes',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '101',
        type: 'fontSizes'
      },
      name: 'FONT_SIZE_15',
      attributes: {},
      path: ['fontSize', '15']
    }
  },
  letterSpacing: {
    '0': {
      value: '0.5',
      type: 'letterSpacing',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '0.5',
        type: 'letterSpacing'
      },
      name: 'LETTER_SPACING_0',
      attributes: {},
      path: ['letterSpacing', '0']
    },
    '1': {
      value: '1.5',
      type: 'letterSpacing',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '1.5',
        type: 'letterSpacing'
      },
      name: 'LETTER_SPACING_1',
      attributes: {},
      path: ['letterSpacing', '1']
    },
    '2': {
      value: '1',
      type: 'letterSpacing',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '1',
        type: 'letterSpacing'
      },
      name: 'LETTER_SPACING_2',
      attributes: {},
      path: ['letterSpacing', '2']
    },
    '3': {
      value: '0',
      type: 'letterSpacing',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '0',
        type: 'letterSpacing'
      },
      name: 'LETTER_SPACING_3',
      attributes: {},
      path: ['letterSpacing', '3']
    },
    '4': {
      value: '0.15',
      type: 'letterSpacing',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '0.15',
        type: 'letterSpacing'
      },
      name: 'LETTER_SPACING_4',
      attributes: {},
      path: ['letterSpacing', '4']
    },
    '5': {
      value: '0.1',
      type: 'letterSpacing',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '0.1',
        type: 'letterSpacing'
      },
      name: 'LETTER_SPACING_5',
      attributes: {},
      path: ['letterSpacing', '5']
    },
    '6': {
      value: '0.35',
      type: 'letterSpacing',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '0.35',
        type: 'letterSpacing'
      },
      name: 'LETTER_SPACING_6',
      attributes: {},
      path: ['letterSpacing', '6']
    },
    '7': {
      value: '0.25',
      type: 'letterSpacing',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '0.25',
        type: 'letterSpacing'
      },
      name: 'LETTER_SPACING_7',
      attributes: {},
      path: ['letterSpacing', '7']
    },
    '8': {
      value: '0.45',
      type: 'letterSpacing',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '0.45',
        type: 'letterSpacing'
      },
      name: 'LETTER_SPACING_8',
      attributes: {},
      path: ['letterSpacing', '8']
    },
    '9': {
      value: '0.4',
      type: 'letterSpacing',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '0.4',
        type: 'letterSpacing'
      },
      name: 'LETTER_SPACING_9',
      attributes: {},
      path: ['letterSpacing', '9']
    },
    '10': {
      value: '0.14',
      type: 'letterSpacing',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '0.14',
        type: 'letterSpacing'
      },
      name: 'LETTER_SPACING_10',
      attributes: {},
      path: ['letterSpacing', '10']
    },
    '11': {
      value: '0.17',
      type: 'letterSpacing',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '0.17',
        type: 'letterSpacing'
      },
      name: 'LETTER_SPACING_11',
      attributes: {},
      path: ['letterSpacing', '11']
    }
  },
  paragraphSpacing: {
    '0': {
      value: '0',
      type: 'paragraphSpacing',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '0',
        type: 'paragraphSpacing'
      },
      name: 'PARAGRAPH_SPACING_0',
      attributes: {},
      path: ['paragraphSpacing', '0']
    }
  },
  title: {
    h1: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '120%',
        fontSize: '101',
        letterSpacing: '0.5',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.0}',
          fontSize: '{fontSize.15}',
          letterSpacing: '{letterSpacing.0}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'TITLE_H1',
      attributes: {},
      path: ['title', 'h1']
    },
    h2: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '120%',
        fontSize: '63',
        letterSpacing: '1.5',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.0}',
          fontSize: '{fontSize.14}',
          letterSpacing: '{letterSpacing.1}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'TITLE_H2',
      attributes: {},
      path: ['title', 'h2']
    },
    h3: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '115%',
        fontSize: '51',
        letterSpacing: '1',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.1}',
          fontSize: '{fontSize.13}',
          letterSpacing: '{letterSpacing.2}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'TITLE_H3',
      attributes: {},
      path: ['title', 'h3']
    },
    h4: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '120%',
        fontSize: '36',
        letterSpacing: '0.5',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.0}',
          fontSize: '{fontSize.12}',
          letterSpacing: '{letterSpacing.0}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'TITLE_H4',
      attributes: {},
      path: ['title', 'h4']
    },
    h5: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Medium',
        lineHeight: '130%',
        fontSize: '25',
        letterSpacing: '0',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-1}',
          lineHeight: '{lineHeights.2}',
          fontSize: '{fontSize.11}',
          letterSpacing: '{letterSpacing.3}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'TITLE_H5',
      attributes: {},
      path: ['title', 'h5']
    },
    h6: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'SemiBold',
        lineHeight: '160%',
        fontSize: '21',
        letterSpacing: '0.15',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-2}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.9}',
          letterSpacing: '{letterSpacing.4}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'TITLE_H6',
      attributes: {},
      path: ['title', 'h6']
    }
  },
  body: {
    titleLarge: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Bold',
        lineHeight: '150%',
        fontSize: '17',
        letterSpacing: '0.1',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-3}',
          lineHeight: '{lineHeights.4}',
          fontSize: '{fontSize.7}',
          letterSpacing: '{letterSpacing.5}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'BODY_TITLE_LARGE',
      attributes: {},
      path: ['body', 'titleLarge']
    },
    titleMedium: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Bold',
        lineHeight: '150%',
        fontSize: '15',
        letterSpacing: '0.1',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-3}',
          lineHeight: '{lineHeights.4}',
          fontSize: '{fontSize.6}',
          letterSpacing: '{letterSpacing.5}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'BODY_TITLE_MEDIUM',
      attributes: {},
      path: ['body', 'titleMedium']
    },
    subtitleLarge: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'SemiBold',
        lineHeight: '140%',
        fontSize: '17',
        letterSpacing: '0.15',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-2}',
          lineHeight: '{lineHeights.5}',
          fontSize: '{fontSize.7}',
          letterSpacing: '{letterSpacing.4}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'BODY_SUBTITLE_LARGE',
      attributes: {},
      path: ['body', 'subtitleLarge']
    },
    subtitleMedium: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'SemiBold',
        lineHeight: '150%',
        fontSize: '15',
        letterSpacing: '0.1',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-2}',
          lineHeight: '{lineHeights.4}',
          fontSize: '{fontSize.6}',
          letterSpacing: '{letterSpacing.5}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'BODY_SUBTITLE_MEDIUM',
      attributes: {},
      path: ['body', 'subtitleMedium']
    },
    subtitleSmall: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'SemiBold',
        lineHeight: '150%',
        fontSize: '13',
        letterSpacing: '0.1',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-2}',
          lineHeight: '{lineHeights.4}',
          fontSize: '{fontSize.4}',
          letterSpacing: '{letterSpacing.5}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'BODY_SUBTITLE_SMALL',
      attributes: {},
      path: ['body', 'subtitleSmall']
    },
    subtitleXsmall: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'SemiBold',
        lineHeight: '140%',
        fontSize: '11',
        letterSpacing: '0.1',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-2}',
          lineHeight: '{lineHeights.5}',
          fontSize: '{fontSize.2}',
          letterSpacing: '{letterSpacing.5}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'BODY_SUBTITLE_XSMALL',
      attributes: {},
      path: ['body', 'subtitleXsmall']
    },
    bodyLarge: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '160%',
        fontSize: '17',
        letterSpacing: '0.35',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.7}',
          letterSpacing: '{letterSpacing.6}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'BODY_BODY_LARGE',
      attributes: {},
      path: ['body', 'bodyLarge']
    },
    bodyMedium: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '160%',
        fontSize: '15',
        letterSpacing: '0.25',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.6}',
          letterSpacing: '{letterSpacing.7}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'BODY_BODY_MEDIUM',
      attributes: {},
      path: ['body', 'bodyMedium']
    },
    bodySmall: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '160%',
        fontSize: '13',
        letterSpacing: '0.15',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.4}',
          letterSpacing: '{letterSpacing.4}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'BODY_BODY_SMALL',
      attributes: {},
      path: ['body', 'bodySmall']
    },
    bodyXSmall: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '160%',
        fontSize: '11',
        letterSpacing: '0',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.2}',
          letterSpacing: '{letterSpacing.3}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'BODY_BODY_X_SMALL',
      attributes: {},
      path: ['body', 'bodyXSmall']
    },
    bodyXXSmall: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '160%',
        fontSize: '9',
        letterSpacing: '0',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.0}',
          letterSpacing: '{letterSpacing.3}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'BODY_BODY_XX_SMALL',
      attributes: {},
      path: ['body', 'bodyXXSmall']
    }
  },
  component: {
    buttonLarge: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'SemiBold',
        lineHeight: '150%',
        fontSize: '13',
        letterSpacing: '0.45',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'uppercase',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-2}',
          lineHeight: '{lineHeights.4}',
          fontSize: '{fontSize.4}',
          letterSpacing: '{letterSpacing.8}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.uppercase}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'COMPONENT_BUTTON_LARGE',
      attributes: {},
      path: ['component', 'buttonLarge']
    },
    buttonMedium: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'SemiBold',
        lineHeight: '160%',
        fontSize: '12',
        letterSpacing: '0.4',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'uppercase',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-2}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.3}',
          letterSpacing: '{letterSpacing.9}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.uppercase}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'COMPONENT_BUTTON_MEDIUM',
      attributes: {},
      path: ['component', 'buttonMedium']
    },
    buttonSmall: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'SemiBold',
        lineHeight: '160%',
        fontSize: '11',
        letterSpacing: '0.35',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'uppercase',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-2}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.2}',
          letterSpacing: '{letterSpacing.6}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.uppercase}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'COMPONENT_BUTTON_SMALL',
      attributes: {},
      path: ['component', 'buttonSmall']
    },
    caption: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '160%',
        fontSize: '13',
        letterSpacing: '0.4',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.4}',
          letterSpacing: '{letterSpacing.9}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'COMPONENT_CAPTION',
      attributes: {},
      path: ['component', 'caption']
    },
    overline: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '160%',
        fontSize: '10',
        letterSpacing: '0.5',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'uppercase',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.1}',
          letterSpacing: '{letterSpacing.0}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.uppercase}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'COMPONENT_OVERLINE',
      attributes: {},
      path: ['component', 'overline']
    },
    tag: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Bold',
        lineHeight: '160%',
        fontSize: '10',
        letterSpacing: '0',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-3}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.1}',
          letterSpacing: '{letterSpacing.3}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'COMPONENT_TAG',
      attributes: {},
      path: ['component', 'tag']
    },
    avatarLetter: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '160%',
        fontSize: '21',
        letterSpacing: '0.14',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.9}',
          letterSpacing: '{letterSpacing.10}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'COMPONENT_AVATAR_LETTER',
      attributes: {},
      path: ['component', 'avatarLetter']
    },
    inputLabel: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '160%',
        fontSize: '12',
        letterSpacing: '0.15',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.3}',
          letterSpacing: '{letterSpacing.4}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'COMPONENT_INPUT_LABEL',
      attributes: {},
      path: ['component', 'inputLabel']
    },
    helperText: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '160%',
        fontSize: '12',
        letterSpacing: '0.4',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.3}',
          letterSpacing: '{letterSpacing.9}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'COMPONENT_HELPER_TEXT',
      attributes: {},
      path: ['component', 'helperText']
    },
    inputText: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '160%',
        fontSize: '15',
        letterSpacing: '0.15',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.6}',
          letterSpacing: '{letterSpacing.4}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'COMPONENT_INPUT_TEXT',
      attributes: {},
      path: ['component', 'inputText']
    },
    chip: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '120%',
        fontSize: '13',
        letterSpacing: '0',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.0}',
          fontSize: '{fontSize.4}',
          letterSpacing: '{letterSpacing.3}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'COMPONENT_CHIP',
      attributes: {},
      path: ['component', 'chip']
    },
    tooltip: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'SemiBold',
        lineHeight: '160%',
        fontSize: '11',
        letterSpacing: '0',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-2}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.2}',
          letterSpacing: '{letterSpacing.3}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'COMPONENT_TOOLTIP',
      attributes: {},
      path: ['component', 'tooltip']
    },
    alertTitle: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Medium',
        lineHeight: '160%',
        fontSize: '15',
        letterSpacing: '0.15',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-1}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.6}',
          letterSpacing: '{letterSpacing.4}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'COMPONENT_ALERT_TITLE',
      attributes: {},
      path: ['component', 'alertTitle']
    },
    tableHeader: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Medium',
        lineHeight: '160%',
        fontSize: '14',
        letterSpacing: '0.17',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-1}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.5}',
          letterSpacing: '{letterSpacing.11}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'COMPONENT_TABLE_HEADER',
      attributes: {},
      path: ['component', 'tableHeader']
    },
    badgeLabel: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Medium',
        lineHeight: '160%',
        fontSize: '12',
        letterSpacing: '0.14',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-1}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.3}',
          letterSpacing: '{letterSpacing.10}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'COMPONENT_BADGE_LABEL',
      attributes: {},
      path: ['component', 'badgeLabel']
    }
  },
  graph: {
    tooltipLabel: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '160%',
        fontSize: '22',
        letterSpacing: '0',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.10}',
          letterSpacing: '{letterSpacing.3}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'GRAPH_TOOLTIP_LABEL',
      attributes: {},
      path: ['graph', 'tooltipLabel']
    },
    tooltipSubLabel: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '160%',
        fontSize: '14',
        letterSpacing: '0',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.5}',
          letterSpacing: '{letterSpacing.3}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'GRAPH_TOOLTIP_SUB_LABEL',
      attributes: {},
      path: ['graph', 'tooltipSubLabel']
    },
    chartTitle: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '160%',
        fontSize: '18',
        letterSpacing: '0',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.8}',
          letterSpacing: '{letterSpacing.3}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'GRAPH_CHART_TITLE',
      attributes: {},
      path: ['graph', 'chartTitle']
    },
    chartSubtitle: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '160%',
        fontSize: '14',
        letterSpacing: '0',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.5}',
          letterSpacing: '{letterSpacing.3}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'GRAPH_CHART_SUBTITLE',
      attributes: {},
      path: ['graph', 'chartSubtitle']
    },
    dataLabel: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '160%',
        fontSize: '22',
        letterSpacing: '0',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.10}',
          letterSpacing: '{letterSpacing.3}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'GRAPH_DATA_LABEL',
      attributes: {},
      path: ['graph', 'dataLabel']
    },
    dataSublabel: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '160%',
        fontSize: '14',
        letterSpacing: '0',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.5}',
          letterSpacing: '{letterSpacing.3}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'GRAPH_DATA_SUBLABEL',
      attributes: {},
      path: ['graph', 'dataSublabel']
    },
    axisLabel: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '160%',
        fontSize: '12',
        letterSpacing: '0',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.3}',
          letterSpacing: '{letterSpacing.3}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'GRAPH_AXIS_LABEL',
      attributes: {},
      path: ['graph', 'axisLabel']
    },
    legendLabel: {
      value: {
        fontFamily: 'Lato',
        fontWeight: 'Regular',
        lineHeight: '160%',
        fontSize: '12',
        letterSpacing: '0',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.lato}',
          fontWeight: '{fontWeights.lato-0}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.3}',
          letterSpacing: '{letterSpacing.3}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'GRAPH_LEGEND_LABEL',
      attributes: {},
      path: ['graph', 'legendLabel']
    }
  },
  documentation: {
    title: {
      value: {
        fontFamily: 'Roboto',
        fontWeight: 'Regular',
        lineHeight: '160%',
        fontSize: '22',
        letterSpacing: '0.15',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.roboto}',
          fontWeight: '{fontWeights.roboto-4}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.10}',
          letterSpacing: '{letterSpacing.4}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'DOCUMENTATION_TITLE',
      attributes: {},
      path: ['documentation', 'title']
    },
    subtitle: {
      value: {
        fontFamily: 'Roboto',
        fontWeight: 'Regular',
        lineHeight: '160%',
        fontSize: '12',
        letterSpacing: '0.15',
        paragraphSpacing: '0',
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none'
      },
      type: 'typography',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: {
          fontFamily: '{fontFamilies.roboto}',
          fontWeight: '{fontWeights.roboto-4}',
          lineHeight: '{lineHeights.3}',
          fontSize: '{fontSize.3}',
          letterSpacing: '{letterSpacing.4}',
          paragraphSpacing: '{paragraphSpacing.0}',
          paragraphIndent: '{paragraphIndent.0}',
          textCase: '{textCase.none}',
          textDecoration: '{textDecoration.none}'
        },
        type: 'typography'
      },
      name: 'DOCUMENTATION_SUBTITLE',
      attributes: {},
      path: ['documentation', 'subtitle']
    }
  },
  textCase: {
    none: {
      value: 'none',
      type: 'textCase',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'none',
        type: 'textCase'
      },
      name: 'TEXT_CASE_NONE',
      attributes: {},
      path: ['textCase', 'none']
    },
    uppercase: {
      value: 'uppercase',
      type: 'textCase',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'uppercase',
        type: 'textCase'
      },
      name: 'TEXT_CASE_UPPERCASE',
      attributes: {},
      path: ['textCase', 'uppercase']
    }
  },
  textDecoration: {
    none: {
      value: 'none',
      type: 'textDecoration',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: 'none',
        type: 'textDecoration'
      },
      name: 'TEXT_DECORATION_NONE',
      attributes: {},
      path: ['textDecoration', 'none']
    }
  },
  paragraphIndent: {
    '0': {
      value: '0px',
      type: 'dimension',
      filePath: 'tokens/contextual.json',
      isSource: false,
      original: {
        value: '0px',
        type: 'dimension'
      },
      name: 'PARAGRAPH_INDENT_0',
      attributes: {},
      path: ['paragraphIndent', '0']
    }
  },
  pure: {
    black: {
      value: '#000000',
      type: 'color',
      description: 'Black',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '{gray.1000}',
        type: 'color',
        description: 'Black'
      },
      name: 'PURE_BLACK',
      attributes: {},
      path: ['pure', 'black']
    },
    white: {
      value: '#ffffff',
      type: 'color',
      description: 'White',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '{gray.0}',
        type: 'color',
        description: 'White'
      },
      name: 'PURE_WHITE',
      attributes: {},
      path: ['pure', 'white']
    }
  },
  cream: {
    '50': {
      value: '#F8F6F4',
      type: 'color',
      description: 'Cream 50',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#F8F6F4',
        type: 'color',
        description: 'Cream 50'
      },
      name: 'CREAM_50',
      attributes: {},
      path: ['cream', '50']
    },
    '100': {
      value: '#F3F1EE',
      type: 'color',
      description: 'Cream 100 (Mkg cream)',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#F3F1EE',
        type: 'color',
        description: 'Cream 100 (Mkg cream)'
      },
      name: 'CREAM_100',
      attributes: {},
      path: ['cream', '100']
    },
    '200': {
      value: '#EFEDEA',
      type: 'color',
      description: 'Cream 200 (Mkg cream 2)',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#EFEDEA',
        type: 'color',
        description: 'Cream 200 (Mkg cream 2)'
      },
      name: 'CREAM_200',
      attributes: {},
      path: ['cream', '200']
    }
  },
  green: {
    '200': {
      value: '#409565',
      type: 'color',
      description: 'Green 200',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#409565',
        type: 'color',
        description: 'Green 200'
      },
      name: 'GREEN_200',
      attributes: {},
      path: ['green', '200']
    },
    '500': {
      value: '#006137',
      type: 'color',
      description: 'Green 500',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#006137',
        type: 'color',
        description: 'Green 500'
      },
      name: 'GREEN_500',
      attributes: {},
      path: ['green', '500']
    },
    '700': {
      value: '#003a13',
      type: 'color',
      description: 'Green 700',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#003a13',
        type: 'color',
        description: 'Green 700'
      },
      name: 'GREEN_700',
      attributes: {},
      path: ['green', '700']
    },
    'A400': {
      value: '#008C50',
      type: 'color',
      description: 'Mkg green',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#008C50',
        type: 'color',
        description: 'Mkg green'
      },
      name: 'GREEN_A400',
      attributes: {},
      path: ['green', 'A400']
    }
  },
  orange: {
    '200': {
      value: '#BD6434',
      type: 'color',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#BD6434',
        type: 'color'
      },
      name: 'ORANGE_200',
      attributes: {},
      path: ['orange', '200']
    },
    '500': {
      value: '#883907',
      type: 'color',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#883907',
        type: 'color'
      },
      name: 'ORANGE_500',
      attributes: {},
      path: ['orange', '500']
    },
    '700': {
      value: '#570A00',
      type: 'color',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#570A00',
        type: 'color'
      },
      name: 'ORANGE_700',
      attributes: {},
      path: ['orange', '700']
    },
    'A400': {
      value: '#F47321',
      type: 'color',
      description: 'Mkg orange',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#F47321',
        type: 'color',
        description: 'Mkg orange'
      },
      name: 'ORANGE_A400',
      attributes: {},
      path: ['orange', 'A400']
    }
  },
  violet: {
    '200': {
      value: '#C04AE0',
      type: 'color',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#C04AE0',
        type: 'color'
      },
      name: 'VIOLET_200',
      attributes: {},
      path: ['violet', '200']
    },
    '500': {
      value: '#8C05AD',
      type: 'color',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#8C05AD',
        type: 'color'
      },
      name: 'VIOLET_500',
      attributes: {},
      path: ['violet', '500']
    },
    '700': {
      value: '#59007D',
      type: 'color',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#59007D',
        type: 'color'
      },
      name: 'VIOLET_700',
      attributes: {},
      path: ['violet', '700']
    },
    'A400': {
      value: '#D541F9',
      type: 'color',
      description: 'Mkg violet',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#D541F9',
        type: 'color',
        description: 'Mkg violet'
      },
      name: 'VIOLET_A400',
      attributes: {},
      path: ['violet', 'A400']
    }
  },
  blue: {
    '200': {
      value: '#5C6CF3',
      type: 'color',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#5C6CF3',
        type: 'color'
      },
      name: 'BLUE_200',
      attributes: {},
      path: ['blue', '200']
    },
    '500': {
      value: '#0841BF',
      type: 'color',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#0841BF',
        type: 'color'
      },
      name: 'BLUE_500',
      attributes: {},
      path: ['blue', '500']
    },
    '700': {
      value: '#001C8E',
      type: 'color',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#001C8E',
        type: 'color'
      },
      name: 'BLUE_700',
      attributes: {},
      path: ['blue', '700']
    },
    'A400': {
      value: '#0841BF',
      type: 'color',
      description: 'Mkg blue',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#0841BF',
        type: 'color',
        description: 'Mkg blue'
      },
      name: 'BLUE_A400',
      attributes: {},
      path: ['blue', 'A400']
    }
  },
  purple: {
    '200': {
      value: '#9D50FF',
      type: 'color',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#9D50FF',
        type: 'color'
      },
      name: 'PURPLE_200',
      attributes: {},
      path: ['purple', '200']
    },
    '500': {
      value: '#651ADA',
      type: 'color',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#651ADA',
        type: 'color'
      },
      name: 'PURPLE_500',
      attributes: {},
      path: ['purple', '500']
    },
    '700': {
      value: '#2100A7',
      type: 'color',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#2100A7',
        type: 'color'
      },
      name: 'PURPLE_700',
      attributes: {},
      path: ['purple', '700']
    },
    'A400': {
      value: '#7128E5',
      type: 'color',
      description: 'Mkg purple',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#7128E5',
        type: 'color',
        description: 'Mkg purple'
      },
      name: 'PURPLE_A400',
      attributes: {},
      path: ['purple', 'A400']
    }
  },
  magenta: {
    '200': {
      value: '#D64E90',
      type: 'color',
      description: 'Pink 200',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#D64E90',
        type: 'color',
        description: 'Pink 200'
      },
      name: 'MAGENTA_200',
      attributes: {},
      path: ['magenta', '200']
    },
    '500': {
      value: '#A11163',
      type: 'color',
      description: 'Pink 500',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#A11163',
        type: 'color',
        description: 'Pink 500'
      },
      name: 'MAGENTA_500',
      attributes: {},
      path: ['magenta', '500']
    },
    '700': {
      value: '#6D0039',
      type: 'color',
      description: 'Pink 700',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#6D0039',
        type: 'color',
        description: 'Pink 700'
      },
      name: 'MAGENTA_700',
      attributes: {},
      path: ['magenta', '700']
    },
    'A400': {
      value: '#E72091',
      type: 'color',
      description: 'Mkg pink',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#E72091',
        type: 'color',
        description: 'Mkg pink'
      },
      name: 'MAGENTA_A400',
      attributes: {},
      path: ['magenta', 'A400']
    }
  },
  foam: {
    '200': {
      value: '#97a9ca',
      type: 'color',
      description: 'Foam 200',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#97a9ca',
        type: 'color',
        description: 'Foam 200'
      },
      name: 'FOAM_200',
      attributes: {},
      path: ['foam', '200']
    },
    '500': {
      value: '#275599',
      type: 'color',
      description: 'Foam 500',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#275599',
        type: 'color',
        description: 'Foam 500'
      },
      name: 'FOAM_500',
      attributes: {},
      path: ['foam', '500']
    },
    '700': {
      value: '#144484',
      type: 'color',
      description: 'Foam 700',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#144484',
        type: 'color',
        description: 'Foam 700'
      },
      name: 'FOAM_700',
      attributes: {},
      path: ['foam', '700']
    },
    'A400': {
      value: '#316ABF',
      type: 'color',
      description: 'Bright Foam',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#316ABF',
        type: 'color',
        description: 'Bright Foam'
      },
      name: 'FOAM_A400',
      attributes: {},
      path: ['foam', 'A400']
    }
  },
  gray: {
    '0': {
      value: '#ffffff',
      type: 'color',
      description: 'White',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#ffffff',
        type: 'color',
        description: 'White'
      },
      name: 'GRAY_0',
      attributes: {},
      path: ['gray', '0']
    },
    '50': {
      value: '#F5F5F5',
      type: 'color',
      description: 'Gray 50',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#F5F5F5',
        type: 'color',
        description: 'Gray 50'
      },
      name: 'GRAY_50',
      attributes: {},
      path: ['gray', '50']
    },
    '100': {
      value: '#E9E9E9',
      type: 'color',
      description: 'Gray 100',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#E9E9E9',
        type: 'color',
        description: 'Gray 100'
      },
      name: 'GRAY_100',
      attributes: {},
      path: ['gray', '100']
    },
    '200': {
      value: '#D9D9D9',
      type: 'color',
      description: 'Gray 200',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#D9D9D9',
        type: 'color',
        description: 'Gray 200'
      },
      name: 'GRAY_200',
      attributes: {},
      path: ['gray', '200']
    },
    '300': {
      value: '#CCCCCB',
      type: 'color',
      description: 'Gray 300 (Mkg light gray)',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#CCCCCB',
        type: 'color',
        description: 'Gray 300 (Mkg light gray)'
      },
      name: 'GRAY_300',
      attributes: {},
      path: ['gray', '300']
    },
    '400': {
      value: '#9D9D9D',
      type: 'color',
      description: 'Gray 400',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#9D9D9D',
        type: 'color',
        description: 'Gray 400'
      },
      name: 'GRAY_400',
      attributes: {},
      path: ['gray', '400']
    },
    '500': {
      value: '#7B7B7B',
      type: 'color',
      description: 'Gray 500',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#7B7B7B',
        type: 'color',
        description: 'Gray 500'
      },
      name: 'GRAY_500',
      attributes: {},
      path: ['gray', '500']
    },
    '600': {
      value: '#545454',
      type: 'color',
      description: 'Gray 600 (Mkg dark gray)',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#545454',
        type: 'color',
        description: 'Gray 600 (Mkg dark gray)'
      },
      name: 'GRAY_600',
      attributes: {},
      path: ['gray', '600']
    },
    '700': {
      value: '#434343',
      type: 'color',
      description: 'Gray 700',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#434343',
        type: 'color',
        description: 'Gray 700'
      },
      name: 'GRAY_700',
      attributes: {},
      path: ['gray', '700']
    },
    '800': {
      value: '#262626',
      type: 'color',
      description: 'gray 800',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#262626',
        type: 'color',
        description: 'gray 800'
      },
      name: 'GRAY_800',
      attributes: {},
      path: ['gray', '800']
    },
    '900': {
      value: '#1d1d1d',
      type: 'color',
      description: 'Gray 900',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#1d1d1d',
        type: 'color',
        description: 'Gray 900'
      },
      name: 'GRAY_900',
      attributes: {},
      path: ['gray', '900']
    },
    '1000': {
      value: '#000000',
      type: 'color',
      description: 'Black',
      filePath: 'tokens/core.json',
      isSource: false,
      original: {
        value: '#000000',
        type: 'color',
        description: 'Black'
      },
      name: 'GRAY_1000',
      attributes: {},
      path: ['gray', '1000']
    }
  }
};
exports["default"] = _default;